import { useEffect, useState } from 'react';
import { ProgressBar } from 'ms-react-progress-bar';
import { Box, Text, useColorMode } from '@chakra-ui/react';

export const Examples = () => {
	const { colorMode } = useColorMode();
	const [dynamicValue, setDynamicValue] = useState(0);

	useEffect(
		() => {
			setTimeout(() => {
				if (dynamicValue >= 100) {
					setDynamicValue(0);
				} else {
					setDynamicValue(prevValue => prevValue + 2);
				}
			}, 1000);
		},
		[dynamicValue]
	);
	return (
		<Box>
			<Text fontSize="2xl" fontWeight="bold">
				Examples
			</Text>
			<Box mb="20px">
				<ProgressBar
					value={30}
					options={{ height: '20px', labelSize: '10px', borderRadius: '20px', barColor: '#4b65fb' }}
				/>
			</Box>
			<Box my="40px">
				<ProgressBar
					value={60}
					options={{
						type: 'striped',
						height: '25px',
						labelSize: '10px',
						labelAlignment: 'right',
						borderRadius: '5px',
						barColor: '#cd004d',
						customLabel: 'Loading...'
					}}
				/>
			</Box>
			<Box my="20px">
				<ProgressBar
					value={80}
					options={{
						height: '25px',
						containerColor: { light: '#1a202c', dark: '#cecece' }[colorMode],
						containerStyle: 'border',
						labelColor: { light: 'black', dark: 'white' }[colorMode],
						labelSize: '10px',
						labelAlignment: 'center',
						borderRadius: '5px',
						barColor: { light: '#1a202c', dark: '#cecece' }[colorMode],
						labelPosition: "top",
						showMaxValue: true,
					}}
				/>
			</Box>
			<Box my="40px">
				<ProgressBar
					value={20}
					options={{
						type: 'striped',
						height: '25px',
						containerStyle: 'border',
						labelColor: { light: 'white', dark: 'black' }[colorMode],
						labelSize: '10px',
						labelAlignment: 'center',
						borderRadius: '50px',
						barColor: { light: '#1a202c', dark: '#cecece' }[colorMode],
						stripeAnimation: true
					}}
				/>
			</Box>
			<Box my="20px">
				<ProgressBar
					value={dynamicValue}
					options={{
						height: '22px',
						labelSize: '10px',
						borderRadius: '50px',
						labelAlignment: 'right',
						containerColor: '#2c43ac',
						containerStyle: 'border'
					}}
				/>
			</Box>
		</Box>
	);
};
